import type { NameInput } from './Avatar.types';

type GetInitialsOptions = Readonly<{
  maxLength?: number;
}>;

const FALLBACK = '?';

/**
 * Derives a plain string from any NameInput variant.
 * Useful as a color seed or accessible label.
 */
export const getNameString = (input: NameInput): string | undefined => {
  if (typeof input === 'string') {
    const trimmed = input.trim();
    return trimmed || undefined;
  }

  const parts = [input.firstName?.trim(), input.lastName?.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : undefined;
};

export const getInitials = (input: NameInput, options: GetInitialsOptions = {}): string => {
  const { maxLength = 2 } = options;

  if (typeof input === 'string') {
    return initialsFromString(input, maxLength);
  }

  const first = input.firstName?.trim();
  const last = input.lastName?.trim();

  if (first && last) {
    return (first[0] + last[0]).toUpperCase().slice(0, maxLength);
  }
  if (first) {
    return first[0].toUpperCase();
  }
  if (last) {
    return last[0].toUpperCase();
  }
  return FALLBACK;
};

const initialsFromString = (str: string, maxLength: number): string => {
  const trimmed = str.trim();
  if (!trimmed) return FALLBACK;

  const words = trimmed.split(/\s+/);
  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }

  return (words[0][0] + words[words.length - 1][0]).toUpperCase().slice(0, maxLength);
};
